/**
 * Rewrite the url to the most optimized version
 *
 * @example
 * ```
 * rewriteUrl({
 *   url: "/home/highlights/image_640.webp",
 *   optimizedMediaSize: "380",
 *   webpSupport: true,
 * })
 * // => "/home/highlights/image_380.webp"
 * ```
 *
 * @param url - The url to rewrite
 * @param optimizedMediaSize - The size of the optimized media
 * @param webpSupport - Whether the browser supports webp images
 * @returns The rewritten url
 */
export function rewriteUrl({
  url,
  optimizedMediaSize,
  webpSupport,
}: {
  url: string | undefined;
  optimizedMediaSize: string;
  webpSupport: boolean;
}) {
  if (!url) {
    return undefined;
  }

  const matches = url.match(/(.*)\/(.*)_(\d*)\.(.*)/);
  if (matches?.length !== 5) {
    return url;
  }
  const [, basePath, name, , extension] = matches;
  const type = ["webp", "jpg", "png"].includes(extension)
    ? "background"
    : extension === "mp4"
      ? "video"
      : undefined;
  if (!type) {
    return url;
  }
  const newPath = `${basePath}/${name}_${optimizedMediaSize}`;
  if (type === "background") {
    if (webpSupport) {
      return `${newPath}.webp`;
    }
    return `${newPath}.jpg`;
  }
  if (type === "video") {
    return `${newPath}.mp4`;
  }
  return url;
}
